export const isObject = (value: any) => value instanceof Object && value.constructor === Object;
